import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getNetSales } from '../services/user'

const initialState = {
  Attendance_Dimension_Viewloading: false,
  Attendance_Dimension_View: [],

  Overall_Avg_Attendance_Rateloading: false,
  Overall_Avg_Attendance_Rate: [],

  School_Performance_Attendanceloading: false,
  School_Performance_Attendance: [],

  Monthly_Attendance_Rate_Trendloading: false,
  Monthly_Attendance_Rate_Trend: [],

  Schools_with_Low_Attendance_Rateloading: false,
  Schools_with_Low_Attendance_Rate: [],

  Attendance_Rate_Distributionloading: false,
  Attendance_Rate_Distribution: [],
  
  Per_of_Students_Absent_Daysloading: false,
  Per_of_Students_Absent_Days: [],

  Attendance_Rate_Distribution_Dimensionloading: false,
  Attendance_Rate_Distribution_Dimension: [],

  Students_Moving_in_and_outloading: false,
  Students_Moving_in_and_out: [],

  Chronic_Absence_Trendloading: false,
  Chronic_Absence_Trend: [],

  Monthly_Attendance_Dimensionloading: false,
  Monthly_Attendance_Dimension: [],

  Student_wise_attendance_popuploading: false,
  Student_wise_attendance_popup: [],

  Student_Absenteesloading: false,
  Student_Absentees: [],

  Student_Absence_Reasonloading: false,
  Student_Absence_Reason: [],

  Student_Absentees_Trendloading: false,
  Student_Absentees_Trend: [],

  Student_Top_tile_school_popuploading: false,
  Student_Top_tile_school_popup: [],

  Student_Top_tile_7day_school_popuploading: false,
  Student_Top_tile_7day_school_popup: [],

  Student_Pop_Up_Absenteeismloading: false,
  Student_Pop_Up_Absenteeism: [],

  Student_Pop_Up_Trendloading: false,
  Student_Pop_Up_Trend: [],

  Absence_by_Buildingloading: false,
  Absence_by_Building: [],
}

export const fetchAttendance_Dimension_View = createAsyncThunk(
  'fetchAttendance_Dimension_View',
  async (Attendance_Dimension_View, thunkAPI) => {
    Attendance_Dimension_View = { ...Attendance_Dimension_View, elasticQueryName: "Attendance Dimension View" }
    const response = await getNetSales(Attendance_Dimension_View);
    return response.data
  }
)

export const fetchOverall_Avg_Attendance_Rate = createAsyncThunk(
  'fetchOverall_Avg_Attendance_Rate',
  async (Overall_Avg_Attendance_Rate, thunkAPI) => {
    Overall_Avg_Attendance_Rate = { ...Overall_Avg_Attendance_Rate, elasticQueryName: "Overall Avg Attendance Rate" }
    const response = await getNetSales(Overall_Avg_Attendance_Rate);
    return response.data
  }
)

export const fetchSchool_Performance_Attendance = createAsyncThunk(
  'fetchSchool_Performance_Attendance',
  async (School_Performance_Attendance, thunkAPI) => {
    School_Performance_Attendance = { ...School_Performance_Attendance, elasticQueryName: "School Performance-Attendance" }
    const response = await getNetSales(School_Performance_Attendance);
    return response.data
  }
)

export const fetchMonthly_Attendance_Rate_Trend = createAsyncThunk(
  'fetchMonthly_Attendance_Rate_Trend',
  async (Monthly_Attendance_Rate_Trend, thunkAPI) => {
    Monthly_Attendance_Rate_Trend = { ...Monthly_Attendance_Rate_Trend, elasticQueryName: "Monthly_Attendance_Rate_Trend" }
    const response = await getNetSales(Monthly_Attendance_Rate_Trend);
    return response.data
  }
)

export const fetchSchools_with_Low_Attendance_Rate = createAsyncThunk(
  'fetchSchools_with_Low_Attendance_Rate',
  async (Schools_with_Low_Attendance_Rate, thunkAPI) => {
    Schools_with_Low_Attendance_Rate = { ...Schools_with_Low_Attendance_Rate, elasticQueryName: "Schools with Low Attendance Rate" }
    const response = await getNetSales(Schools_with_Low_Attendance_Rate);
    return response.data
  }
)

export const fetchAttendance_Rate_Distribution = createAsyncThunk(
  'fetchAttendance_Rate_Distribution',
  async (Attendance_Rate_Distribution, thunkAPI) => {
    Attendance_Rate_Distribution = { ...Attendance_Rate_Distribution, elasticQueryName: "Attendance Rate Distribution" }
    const response = await getNetSales(Attendance_Rate_Distribution);
    return response.data
  }
)

export const fetchPer_of_Students_Absent_Days = createAsyncThunk(
  'fetchPer_of_Students_Absent_Days',
  async (Per_of_Students_Absent_Days, thunkAPI) => {
    Per_of_Students_Absent_Days = { ...Per_of_Students_Absent_Days, elasticQueryName: "% of Students Absent Days" }
    const response = await getNetSales(Per_of_Students_Absent_Days);
    return response.data
  }
)

export const fetchAttendance_Rate_Distribution_Dimension = createAsyncThunk(
  'fetchAttendance_Rate_Distribution_Dimension',
  async (Attendance_Rate_Distribution_Dimension, thunkAPI) => {
    Attendance_Rate_Distribution_Dimension = { ...Attendance_Rate_Distribution_Dimension, elasticQueryName: "Attendance Rate Distribution_Dimension" }
    const response = await getNetSales(Attendance_Rate_Distribution_Dimension);
    return response.data
  }
)

export const fetchStudents_Moving_in_and_out = createAsyncThunk(
  'fetchStudents_Moving_in_and_out',
  async (Students_Moving_in_and_out, thunkAPI) => {
    Students_Moving_in_and_out = { ...Students_Moving_in_and_out, elasticQueryName: "Students Moving in and out of Chronic" }
    const response = await getNetSales(Students_Moving_in_and_out);
    return response.data
  }
)

export const fetchChronic_Absence_Trend = createAsyncThunk(
  'fetchChronic_Absence_Trend',
  async (Chronic_Absence_Trend, thunkAPI) => {
    Chronic_Absence_Trend = { ...Chronic_Absence_Trend, elasticQueryName: "Chronic Absence Trend" }
    const response = await getNetSales(Chronic_Absence_Trend);
    return response.data
  }
)

export const fetchMonthly_Attendance_Dimension = createAsyncThunk(
  'fetchMonthly_Attendance_Dimension',
  async (Monthly_Attendance_Dimension, thunkAPI) => {
    Monthly_Attendance_Dimension = { ...Monthly_Attendance_Dimension, elasticQueryName: "Monthly_Attendance_Dimension" }
    const response = await getNetSales(Monthly_Attendance_Dimension);
    return response.data
  }
)

export const fetchStudent_wise_attendance_popup = createAsyncThunk(
  'fetchStudent_wise_attendance_popup',
  async (Student_wise_attendance_popup, thunkAPI) => {
    Student_wise_attendance_popup = { ...Student_wise_attendance_popup, elasticQueryName: "Student_wise_attendance_popup" }
    const response = await getNetSales(Student_wise_attendance_popup);
    return response.data
  }
)

export const fetchStudent_Absentees = createAsyncThunk(
  'fetchStudent_Absentees',
  async (Student_Absentees, thunkAPI) => {
    Student_Absentees = { ...Student_Absentees, elasticQueryName: "Student_Absentees" }
    const response = await getNetSales(Student_Absentees);
    return response.data
  }
)

export const fetchStudent_Absence_Reason = createAsyncThunk(
  'fetchStudent_Absence_Reason',
  async (Student_Absence_Reason, thunkAPI) => {
    Student_Absence_Reason = { ...Student_Absence_Reason, elasticQueryName: "Student Absence Reason" }
    const response = await getNetSales(Student_Absence_Reason);
    return response.data
  }
)

export const fetchStudent_Absentees_Trend = createAsyncThunk(
  'fetchStudent_Absentees_Trend',
  async (Student_Absentees_Trend, thunkAPI) => {
    Student_Absentees_Trend = { ...Student_Absentees_Trend, elasticQueryName: "Student Absentees Trend" }
    const response = await getNetSales(Student_Absentees_Trend);
    return response.data
  }
)

export const fetchStudent_Top_tile_school_popup = createAsyncThunk(
  'fetchStudent_Top_tile_school_popup',
  async (Student_Top_tile_school_popup, thunkAPI) => {
    Student_Top_tile_school_popup = { ...Student_Top_tile_school_popup, elasticQueryName: "Student_Top_tile_school_popup" }
    const response = await getNetSales(Student_Top_tile_school_popup);
    return response.data
  }
)

export const fetchStudent_Top_tile_7day_school_popup = createAsyncThunk(
  'fetchStudent_Top_tile_7day_school_popup',
  async (Student_Top_tile_7day_school_popup, thunkAPI) => {
    Student_Top_tile_7day_school_popup = { ...Student_Top_tile_7day_school_popup, elasticQueryName: "Student_Top_tile_7day_school_popup" }
    const response = await getNetSales(Student_Top_tile_7day_school_popup);
    return response.data
  }
)

export const fetchStudent_Pop_Up_Absenteeism = createAsyncThunk(
  'fetchStudent_Pop_Up_Absenteeism',
  async (Student_Pop_Up_Absenteeism, thunkAPI) => {
    Student_Pop_Up_Absenteeism = { ...Student_Pop_Up_Absenteeism, elasticQueryName: "Student Pop_Up_Absenteeism" }
    const response = await getNetSales(Student_Pop_Up_Absenteeism);
    return response.data
  }
)

export const fetchStudent_Pop_Up_Trend = createAsyncThunk(
  'fetchStudent_Pop_Up_Trend',
  async (Student_Pop_Up_Trend, thunkAPI) => {
    Student_Pop_Up_Trend = { ...Student_Pop_Up_Trend, elasticQueryName: "Student Pop_Up_Trend" }
    const response = await getNetSales(Student_Pop_Up_Trend);
    return response.data
  }
)

export const fetchAbsence_by_Building = createAsyncThunk(
  'fetchAbsence_by_Building',
  async (Absence_by_Building, thunkAPI) => {
    Absence_by_Building = { ...Absence_by_Building, elasticQueryName: "Absence_by_Building" }
    const response = await getNetSales(Absence_by_Building);
    return response.data
  }
)

export const attendance = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAttendance_Dimension_View.fulfilled, (state, action) => {
      state.Attendance_Dimension_View = action.payload;
      state.Attendance_Dimension_Viewloading = false;
    }).addCase(fetchAttendance_Dimension_View.pending, (state, action) => {
      state.Attendance_Dimension_Viewloading = true;
    })

    builder.addCase(fetchOverall_Avg_Attendance_Rate.fulfilled, (state, action) => {
      state.Overall_Avg_Attendance_Rateloading = false;
      state.Overall_Avg_Attendance_Rate = action.payload;
    }).addCase(fetchOverall_Avg_Attendance_Rate.pending, (state, action) => {
      state.Overall_Avg_Attendance_Rateloading = true;
    })

    builder.addCase(fetchSchool_Performance_Attendance.fulfilled, (state, action) => {
      state.School_Performance_Attendanceloading = false;
      state.School_Performance_Attendance = action.payload;
    }).addCase(fetchSchool_Performance_Attendance.pending, (state, action) => {
      state.School_Performance_Attendanceloading = true;
    })

    builder.addCase(fetchMonthly_Attendance_Rate_Trend.fulfilled, (state, action) => {
      state.Monthly_Attendance_Rate_Trendloading = false;
      state.Monthly_Attendance_Rate_Trend = action.payload;
    }).addCase(fetchMonthly_Attendance_Rate_Trend.pending, (state, action) => {
      state.Monthly_Attendance_Rate_Trendloading = true;
    })

    builder.addCase(fetchSchools_with_Low_Attendance_Rate.fulfilled, (state, action) => {
      state.Schools_with_Low_Attendance_Rate = action.payload;
      state.Schools_with_Low_Attendance_Rateloading = false;
    }).addCase(fetchSchools_with_Low_Attendance_Rate.pending, (state, action) => {
      state.Schools_with_Low_Attendance_Rateloading = true;
    })

    builder.addCase(fetchAttendance_Rate_Distribution.fulfilled, (state, action) => {
      state.Attendance_Rate_Distribution = action.payload;
      state.Attendance_Rate_Distributionloading = false;
    }).addCase(fetchAttendance_Rate_Distribution.pending, (state, action) => {
      state.Attendance_Rate_Distributionloading = true;
    })

    builder.addCase(fetchPer_of_Students_Absent_Days.fulfilled, (state, action) => {
      state.Per_of_Students_Absent_Days = action.payload;
      state.Per_of_Students_Absent_Daysloading = false;
    }).addCase(fetchPer_of_Students_Absent_Days.pending, (state, action) => {
      state.Per_of_Students_Absent_Daysloading = true;
    })

    builder.addCase(fetchAttendance_Rate_Distribution_Dimension.fulfilled, (state, action) => {
      state.Attendance_Rate_Distribution_Dimension = action.payload;
      state.Attendance_Rate_Distribution_Dimensionloading = false;
    }).addCase(fetchAttendance_Rate_Distribution_Dimension.pending, (state, action) => {
      state.Attendance_Rate_Distribution_Dimensionloading = true;
    })

    builder.addCase(fetchStudents_Moving_in_and_out.fulfilled, (state, action) => {
      state.Students_Moving_in_and_out = action.payload;
      state.Students_Moving_in_and_outloading = false;
    }).addCase(fetchStudents_Moving_in_and_out.pending, (state, action) => {
      state.Students_Moving_in_and_outloading = true;
    })

    builder.addCase(fetchChronic_Absence_Trend.fulfilled, (state, action) => {
      state.Chronic_Absence_Trend = action.payload;
      state.Chronic_Absence_Trendloading = false;
    }).addCase(fetchChronic_Absence_Trend.pending, (state, action) => {
      state.Chronic_Absence_Trendloading = true;
    })

    builder.addCase(fetchMonthly_Attendance_Dimension.fulfilled, (state, action) => {
      state.Monthly_Attendance_Dimension = action.payload;
      state.Monthly_Attendance_Dimensionloading = false;
    }).addCase(fetchMonthly_Attendance_Dimension.pending, (state, action) => {
      state.Monthly_Attendance_Dimensionloading = true;
    })

    builder.addCase(fetchStudent_wise_attendance_popup.fulfilled, (state, action) => {
      state.Student_wise_attendance_popup = action.payload;
      state.Student_wise_attendance_popuploading = false;
    }).addCase(fetchStudent_wise_attendance_popup.pending, (state, action) => {
      state.Student_wise_attendance_popuploading = true;
    })

    builder.addCase(fetchStudent_Absentees.fulfilled, (state, action) => {
      state.Student_Absentees = action.payload;
      state.Student_Absenteesloading = false;
    }).addCase(fetchStudent_Absentees.pending, (state, action) => {
      state.Student_Absenteesloading = true;
    })

    builder.addCase(fetchStudent_Absence_Reason.fulfilled, (state, action) => {
      state.Student_Absence_Reason = action.payload;
      state.Student_Absence_Reasonloading = false;
    }).addCase(fetchStudent_Absence_Reason.pending, (state, action) => {
      state.Student_Absence_Reasonloading = true;
    })

    builder.addCase(fetchStudent_Absentees_Trend.fulfilled, (state, action) => {
      state.Student_Absentees_Trend = action.payload;
      state.Student_Absentees_Trendloading = false;
    }).addCase(fetchStudent_Absentees_Trend.pending, (state, action) => {
      state.Student_Absentees_Trendloading = true;
    })

    builder.addCase(fetchStudent_Top_tile_school_popup.fulfilled, (state, action) => {
      state.Student_Top_tile_school_popup = action.payload;
      state.Student_Top_tile_school_popuploading = false;
    }).addCase(fetchStudent_Top_tile_school_popup.pending, (state, action) => {
      state.Student_Top_tile_school_popuploading = true;
    })

    builder.addCase(fetchStudent_Top_tile_7day_school_popup.fulfilled, (state, action) => {
      state.Student_Top_tile_7day_school_popup = action.payload;
      state.Student_Top_tile_7day_school_popuploading = false;
    }).addCase(fetchStudent_Top_tile_7day_school_popup.pending, (state, action) => {
      state.Student_Top_tile_7day_school_popuploading = true;
    })

    builder.addCase(fetchStudent_Pop_Up_Absenteeism.fulfilled, (state, action) => {
      state.Student_Pop_Up_Absenteeism = action.payload;
      state.Student_Pop_Up_Absenteeismloading = false;
    }).addCase(fetchStudent_Pop_Up_Absenteeism.pending, (state, action) => {
      state.Student_Pop_Up_Absenteeismloading = true;
    })

    builder.addCase(fetchStudent_Pop_Up_Trend.fulfilled, (state, action) => {
      state.Student_Pop_Up_Trend = action.payload;
      state.Student_Pop_Up_Trendloading = false;
    }).addCase(fetchStudent_Pop_Up_Trend.pending, (state, action) => {
      state.Student_Pop_Up_Trendloading = true;
    })

    builder.addCase(fetchAbsence_by_Building.fulfilled, (state, action) => {
      state.Absence_by_Building = action.payload;
      state.Absence_by_Buildingloading = false;
    }).addCase(fetchAbsence_by_Building.pending, (state, action) => {
      state.Absence_by_Buildingloading = true;
    })
  }

})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = counterSlice.actions

export default attendance.reducer